import { render, staticRenderFns } from "./edit-prospect.vue?vue&type=template&id=651763a4&"
import script from "./edit-prospect.vue?vue&type=script&lang=js&"
export * from "./edit-prospect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports